import React, {useState} from 'react';
import {
  IconCar,
  IconCopy,
  IconDoc,
  IconLocation,
  IconWarning,
  // IconCheck,
  // IconChevronLeft,
  // IconChevronRight,
  // IconSpinner,
} from "../../../../../components/icons";
import {useFormik} from "formik";
import {Sinistre} from "../../../../../components/models";
import {createSinistre, updateSinistre} from "../../../../../components/requests";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";

interface SinistreFormProps {
  immatriculation?: string;
  expert?: string;
  referenceExpert?: string;
  referencePartenaire?: string;
  typeSinistre?: string;
  dateSinistre?: string;
  certificatImmatriculation?: string;
  dateCertificatImmat?: string;
  site?: string;
  etat?: string;
  choc?: string;
}

type SinistreErrors = Partial<Record<keyof SinistreFormProps, string>>;

const validate = (values: SinistreFormProps): SinistreErrors => {
  const errors: SinistreErrors = {};

  if (!values.immatriculation || values.immatriculation.trim().length === 0) {
    errors.immatriculation = 'Ce champ est requis';
  }
  if (!values.expert) {
    errors.expert = 'Ce champ est requis';
  }
  if (!values.typeSinistre) {
    errors.typeSinistre = 'Ce champ est requis';
  }
  if (!values.dateSinistre) {
    errors.dateSinistre = 'Ce champ est requis';
  }
  if (!values.certificatImmatriculation) {
    errors.certificatImmatriculation = 'Ce champ est requis';
  }
  if (!values.dateCertificatImmat) {
    errors.dateCertificatImmat = 'Ce champ est requis';
  }

  return errors;
};

const SinistreForm = (
  {
    sinistre = null,
    setSinistre = null,
    formatEtatChoc,
    // setIsActive = null
  }: {
    sinistre?: Sinistre | null,
    setSinistre?: any | null,
    formatEtatChoc?: any | null,
    // setIsActive?: any | null,
  }) => {
  const {id} = useParams();
  const [sinistreId, setSinistreId] = useState<number | null>(null);
  // const [isValideLoading, setIsValideLoading] = useState<boolean>(false);
  // const [isBrouillonLoading, setIsBrouillonLoading] = useState<boolean>(false);
  // const [isBrouillon, setIsBrouillon] = useState<boolean | null>(null);
  const [checkCopy, setCheckCopy] = useState<string | null>(null)

  const formik = useFormik({
    initialValues: {
      immatriculation: sinistre ? sinistre.immatriculation : '',
      expert: sinistre ? sinistre.expert : '',
      referenceExpert: sinistre ? sinistre.referenceExpert : '',
      referencePartenaire: sinistre ? sinistre.referencePartenaire : '',
      typeSinistre: sinistre ? sinistre.typeSinistre : '',
      dateSinistre: sinistre ? sinistre.dateSinistre?.split('T')[0] : '',
      certificatImmatriculation: sinistre ? sinistre.certificatImmatriculation ? "Oui" : "Non" : '',
      dateCertificatImmat: sinistre ? sinistre.dateCertificatImmat?.split('T')[0] : '',
      site: sinistre ? sinistre.site : '',
      etat: sinistre ? sinistre.etat : '',
      choc: sinistre ? sinistre.choc : '',
    },
    enableReinitialize: true,
    validate,
    onSubmit: (values: SinistreFormProps) => {
      // if (isBrouillon) setIsBrouillonLoading(true)
      // else setIsValideLoading(true);

      let payload = {
        ...values,
        certificatImmatriculation: (values.certificatImmatriculation === "Oui"),
        // brouillon: isBrouillon,
        ...((!sinistre) ? {dossier: `api/dossiers/${id}`} : {})
      };

      const method = (!sinistre) ? createSinistre(payload) : updateSinistre((sinistre.id) ? sinistre.id : sinistreId, payload)
      method
        .then((response) => {
          if ((response.status === 200 || response.status === 201) && response.data !== undefined) {
            setSinistre({
              ...((!sinistre) ? {} : {id: sinistre.id}),
              immatriculation: payload.immatriculation,
              expert: payload.expert,
              referenceExpert: payload.referenceExpert,
              referencePartenaire: payload.referencePartenaire,
              typeSinistre: payload.typeSinistre,
              dateSinistre: payload.dateSinistre,
              certificatImmatriculation: payload.certificatImmatriculation,
              dateCertificatImmat: payload.dateCertificatImmat,
              site: payload.site,
              etat: payload.etat,
              choc: payload.choc,
              // brouillon: payload.brouillon,
            })
            if (!sinistre) setSinistreId(response.data['@id'].split('/').pop())
            toast.success(`Sinistre ${(!sinistre) ? 'créé' : 'modifié'}`);
          }
        })
        .catch((error) => console.error(error))
        .finally(() => {
          // if (isBrouillon) setIsBrouillonLoading(false)
          // else setIsValideLoading(false);
        })
    },
  });

  const copyText = (
    text: string,
    callback?: (copiedText: string | null) => void,
    delay: number = 500
  ) => {
    if (!text) return

    navigator.clipboard
      .writeText(text)
      .then(() => {
        if (callback) {
          callback(text)
          setTimeout(() => {
            callback(null)
          }, delay)
        }
        toast.info(`${text} copié`)
      })
      .catch((err) => {
        console.error('Erreur de copie :', err)
      })
  }

  const handleCopie = (text) => {
    copyText(text, setCheckCopy, 500)
  }

  return (
    <>
      {/*<form onSubmit={formik.handleSubmit}>*/}
      <div className="p-4 animate-in fade-in duration-300">
        <div className="grid grid-cols-2 gap-4">
          <div className="section-card">
            <div className="section-header">
              <div className="section-icon bg-blue-100 text-blue-600">
                <IconCar/>
              </div>
              <span className="section-title">Dossier</span></div>
            <div className="section-body grid grid-cols-2 gap-3">
              <div className="col-span-2">
                <label className="form-label">Immatriculation</label>
                <div className="flex items-center gap-2">
                  <input
                    name="immatriculation"
                    type="text"
                    className="form-input font-mono uppercase hover:cursor-not-allowed"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.immatriculation}
                    disabled={true}
                    readOnly={true}
                  />
                  {formik.values.immatriculation &&
                    (checkCopy !== formik.values.immatriculation ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        className="cursor-pointer text-gray-500"
                        onClick={() => handleCopie(formik.values.immatriculation)}
                      >
                        <title>Copier</title>
                        <IconCopy/>
                      </svg>
                    ) : (
                      <i className='ki-duotone ki-copy-success text-primary fs-2'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                    ))}
                </div>
                {formik.errors.immatriculation ? <div className="text-xs text-red-600">
                  {formik.errors.immatriculation}
                </div> : null}
              </div>
              <div className="col-span-2">
                <label className="form-label">Expert</label>
                <div className="flex items-center gap-2">
                  <input
                    name="expert"
                    type="text"
                    className="form-input uppercase hover:cursor-not-allowed"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.expert}
                    disabled={true}
                    readOnly={true}
                  />
                  {formik.values.expert &&
                    (checkCopy !== formik.values.expert ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        className="cursor-pointer text-gray-500"
                        onClick={() => handleCopie(formik.values.expert)}
                      >
                        <title>Copier</title>
                        <IconCopy/>
                      </svg>
                    ) : (
                      <i className='ki-duotone ki-copy-success text-primary fs-2'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                    ))}
                </div>
                {formik.errors.expert ? <div className="text-xs text-red-600">
                  {formik.errors.expert}
                </div> : null}
              </div>
              <div>
                <label className="form-label">Référence expert</label>
                <input
                  name="referenceExpert"
                  type="text"
                  className="form-input hover:cursor-not-allowed"
                  placeholder="Réf."
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.referenceExpert}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.referenceExpert ? <div className="text-xs text-red-600">
                  {formik.errors.referenceExpert}
                </div> : null}
              </div>
              <div>
                <label className="form-label">Référence partenaire</label>
                <div className="flex items-center gap-2">
                  <input
                    name="referencePartenaire"
                    type="text"
                    className="form-input hover:cursor-not-allowed"
                    placeholder="Réf."
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.referencePartenaire}
                    disabled={true}
                    readOnly={true}
                  />
                  {formik.values.referencePartenaire &&
                    (checkCopy !== formik.values.referencePartenaire ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        className="cursor-pointer text-gray-500"
                        fill="none"
                        onClick={() => handleCopie(formik.values.referencePartenaire)}
                      >
                        <title>Copier</title>
                        <IconCopy/>
                      </svg>
                    ) : (
                      <i className='ki-duotone ki-copy-success text-primary fs-2'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                    ))}
                </div>
                {formik.errors.referencePartenaire ? <div className="text-xs text-red-600">
                  {formik.errors.referencePartenaire}
                </div> : null}
              </div>
            </div>
          </div>
          <div className="section-card">
            <div className="section-header">
              <div className="section-icon bg-amber-100 text-amber-600">
                <IconWarning/>
              </div>
              <span className="section-title">Sinistre</span>
            </div>
            <div className="section-body grid grid-cols-2 gap-3">
              <div className="col-span-2">
                <label className="form-label">Type de sinistre</label>
                <div className="flex items-center gap-2">
                  <input
                    name="typeSinistre"
                    type="text"
                    className="form-input hover:cursor-not-allowed"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.typeSinistre}
                    disabled={true}
                    readOnly={true}
                  />
                  {formik.values.typeSinistre &&
                    (checkCopy !== formik.values.typeSinistre ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        className="cursor-pointer text-gray-500"
                        fill="none"
                        onClick={() => handleCopie(formik.values.typeSinistre)}
                      >
                        <title>Copier</title>
                        <IconCopy/>
                      </svg>
                    ) : (
                      <i className='ki-duotone ki-copy-success text-primary fs-2'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                    ))}
                </div>
                {formik.errors.typeSinistre ? <div className="text-xs text-red-600">
                  {formik.errors.typeSinistre}
                </div> : null}
              </div>
              <div className="col-span-2">
                <label className="form-label">Date sinistre</label>
                <input
                  name="dateSinistre"
                  type={formik.values.dateSinistre ? "date" : "text"}
                  className="form-input hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.dateSinistre ?? ''}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.dateSinistre ? <div className="text-xs text-red-600">
                  {formik.errors.dateSinistre}
                </div> : null}
              </div>
              <div className="col-span-2">
                <label className="form-label">Etat</label>
                <textarea
                  className="form-input resize-none hover:cursor-not-allowed"
                  rows={4}
                  placeholder="Description de l'etat..."
                  name='etat'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formatEtatChoc(formik.values.etat, 'etat')}
                  disabled
                  readOnly
                ></textarea>
                {formik.errors.etat ? <div className="text-xs text-red-600">
                  {formik.errors.etat}
                </div> : null}
              </div>
              <div className="col-span-2">
                <label className="form-label">Chocs</label>
                <textarea
                  className="form-input resize-none hover:cursor-not-allowed"
                  rows={4}
                  placeholder="Description du choc..."
                  name='choc'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formatEtatChoc(formik.values.choc, 'choc')}
                  disabled
                  readOnly
                ></textarea>
                {formik.errors.choc ? <div className="text-xs text-red-600">
                  {formik.errors.choc}
                </div> : null}
              </div>
            </div>
          </div>
          <div className="section-card">
            <div className="section-header">
              <div className="section-icon bg-green-100 text-green-600">
                <IconDoc/>
              </div>
              <span className="section-title">Documents</span>
            </div>
            <div className="section-body grid grid-cols-2 gap-3">
              <div className="col-span-2">
                <label className="form-label">Certificat Immatriculation</label>
                <select
                  name="certificatImmatriculation"
                  className="form-input form-select hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.certificatImmatriculation}
                  disabled={true}
                >
                  <option></option>
                  <option value="Oui">Oui</option>
                  <option value="Non">Non</option>
                </select>
                {formik.errors.certificatImmatriculation ? <div className="text-xs text-red-600">
                  {formik.errors.certificatImmatriculation}
                </div> : null}
              </div>
              <div className="col-span-2">
                <label className="form-label">Reçu le</label>
                <input
                  name="dateCertificatImmat"
                  type={formik.values.dateCertificatImmat ? "date" : "text"}
                  className="form-input hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.dateCertificatImmat}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.dateCertificatImmat ? <div className="text-xs text-red-600">
                  {formik.errors.dateCertificatImmat}
                </div> : null}
              </div>
            </div>
          </div>
          <div className="section-card">
            <div className="section-header">
              <div className="section-icon bg-purple-100 text-purple-600">
                <IconLocation/>
              </div>
              <span className="section-title">Localisation</span>
            </div>
            <div className="section-body grid grid-cols-2 gap-3">
              <div className="col-span-2">
                <label className="form-label">Site</label>
                <input
                  name="site"
                  type="text"
                  className="form-input hover:cursor-not-allowed"
                  placeholder="Site"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.site}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.site ? <div className="text-xs text-red-600">
                  {formik.errors.site}
                </div> : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      {/*<div className="fixed bottom-0 left-60 right-0 bg-white border-t border-gray-200 py-3 px-4 z-30">*/}
      {/*  <div className="max-w-[1600px] mx-auto flex items-center justify-between">*/}
      {/*    <div className="flex items-center gap-3">*/}
      {/*      <span*/}
      {/*        onClick={() => null}*/}
      {/*        className="px-3 py-1.5 text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        <IconChevronLeft className="w-4 h-4"/>*/}
      {/*        Précédent*/}
      {/*      </span>*/}
      {/*      <span*/}
      {/*        onClick={() => setIsActive('proprietaire')}*/}
      {/*        className="px-3 py-1.5 text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        Suivant*/}
      {/*        <IconChevronRight className="w-4 h-4"/>*/}
      {/*      </span>*/}
      {/*    </div>*/}
      {/*    <div className="flex items-center gap-2">*/}
      {/*      <span*/}
      {/*        onClick={() => formik.resetForm()}*/}
      {/*        className="px-3 py-1.5 border border-gray-300 rounded-lg text-gray-700 text-sm font-medium hover:bg-gray-50 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        Annuler*/}
      {/*      </span>*/}
      {/*      <button*/}
      {/*        type="submit"*/}
      {/*        onClick={() => setIsBrouillon(true)}*/}
      {/*        className="px-3 py-1.5 bg-gray-800 text-white rounded-lg text-sm font-medium hover:bg-gray-900 flex items-center gap-1.5"*/}
      {/*      >*/}
      {/*        {(isBrouillonLoading) && <IconSpinner className="animate-spin w-4 h-4"/>}*/}
      {/*        {(isBrouillonLoading) ? 'Enregistrement' : 'Brouillon'}*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        type="submit"*/}
      {/*        onClick={() => setIsBrouillon(false)}*/}
      {/*        className="px-4 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 flex items-center gap-1.5"*/}
      {/*      >*/}
      {/*        {(isValideLoading) ? <IconSpinner className="animate-spin w-4 h-4"/> : <IconCheck className="w-4 h-4"/>}*/}
      {/*        {(isValideLoading) ? 'Enregistrement' : 'Valider'}*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*</form>*/}
    </>
  );
}

export default SinistreForm;